export const environment = {
	production: false,
	baseUrl: 'https://vitralogycloudapi-qa.azurewebsites.net/api',
	webViewer: {
		licenceKey: "Vitralogy LLC:OEM:Virtual Binder::B+:AMS(20240410):EA570E131FB79AD0D33352184F516F2F2292EC2BBB221909AD3470F054AA31F5C7",
		version: "10.7.3"
	},	
	auth: {
		domain: 'vitralogy-staging.us.auth0.com',
		clientId: 'U0prp1UAO9VPa0dfgGB9h5zpQQb52TQy'
	},
	platforms: {
		vendor: 'https://vitralogyvendorportal-qa.azurewebsites.net',
		customer: 'https://vitralogycustomerportal-qa.azurewebsites.net'
	},
	apis: {
		commonApi: 'https://vitralogycommonapi-qa.azurewebsites.net'
	}
};
